//
//
//
//
//
//

import DashboardDictionaryDatatable from '@/apps/customer-insigths/components/DashboardDictionaryDatatable.vue';
export default {
  name: 'DashboardDictionary',
  components: {
    DashboardDictionaryDatatable: DashboardDictionaryDatatable
  },
  data: function data() {
    return {
      valid: false
    };
  },
  created: function created() {},
  methods: {
    onAdd: function onAdd() {
      this.mostrarFormularioe = true;
    }
  },
  computed: {}
};